<template>
  <div class="signInDetail">
    <audio controls="controls" hidden src="../../../assets/err.mp3" ref="erraudio"></audio>
    <audio controls="controls" hidden src="../../../assets/success.wav" ref="successaudio"></audio>

    <div class="mobileHeader">
      <p>
        <span
          >发货编码：<i>{{ detail.sourceNo }}</i></span
        ><span
          >货柜号：<i>{{ detail.containerNo }}</i></span
        >
      </p>
      <p>
        <span
          >SKU：<i>{{ detail.skuCode }}</i></span
        ><span
          >原仓位：<i>{{ detail.locationCode }}</i></span
        >
      </p>
      <p>
        <span
          >SKU名称：<i>{{ detail.productNameCN }}</i></span
        ><span
          >品牌：<i>{{ detail.brand }}</i></span
        >
      </p>
      <p>
        <span
          >是否带电：<i>{{ detail.isElectricityText }}</i></span
        ><span
          >是否退税：<i>{{ detail.isReturnTaxText }}</i></span
        >
      </p>
      <p>
        <span
          >型号：<i>{{ detail.model }}</i></span
        ><span
          >FNSKU：<i>{{ detail.fnsku }}</i></span
        >
      </p>
      <p>
        <span
          >shipmentid：<i>{{ detail.shipmentID }}</i></span
        ><span
          >采购单：<i>{{ detail.relationNumber }}</i></span
        >
      </p>
    </div>

    <div class="putC_container">
      <div class="putC_search">
        <span>请输入数量</span>
        <div>
          <van-field
            type="digit"
            size="small"
            v-model="search.qty"
            placeholder="数量"
            @change="inputNumChange('qty')"
            ref="boxCount"
          />
        </div>
      </div>
      <div class="putC_search">
        <span>请输入库位</span>
        <div>
          <van-field
            size="small"
            v-model="search.locationCode"
            placeholder="库位"
            right-icon="scan"
            @click-right-icon="scan"
            :formatter="relationNumberFmt"
            ref="storage"
          />
        </div>
      </div>
    </div>

    <div class="putC_table">
      <el-table :data="tableData" border style="width: 100%">
        <el-table-column
          prop="totalNumber"
          label="总数量"
          min-width="70"
          align="center"
        >
        </el-table-column>
        <el-table-column
          prop="storesNumber"
          label="已操作上架数量"
          min-width="120"
          align="center"
        >
        </el-table-column>
        <el-table-column
          prop="placedNumber"
          label="待重新上架数量"
          min-width="120"
          align="center"
        >
        </el-table-column>
      </el-table>
      <p style="font-size: 14px">
        若结束上架，则默认待重新上架数量货物放置待出库区。
      </p>
    </div>

    <div class="putC_footer">
      <button class="submit-btn" @click="submit">确认上架</button>
      <button class="submit-btn confirm-btn" @click="toEndPutaway">
        结束上架
      </button>
    </div>
  </div>
</template>

<script>
import {
  Icon,
  Badge,
  Picker,
  Popup,
  Field,
  Tab,
  Tabs,
  NoticeBar,
  Dialog,
  Toast,
  Checkbox,
} from "vant";
import {
  GetInventoryStorageChangeDetailAsync,
  addPutaway,
  endPutaway,
} from "@/api/mobile/rePutaway_api";
import { mixins } from "../mobileMixins";

export default {
  data() {
    return {
      search: {},
      tableData: [
        {
          totalNumber: "0",
          storesNumber: "0",
          placedNumber: "0",
        },
      ],
      list: {},
      detail: {},
      columns: [],
    };
  },
  components: {
    [Icon.name]: Icon,
    [Badge.name]: Badge,
    [Picker.name]: Picker,
    [Popup.name]: Popup,
    [Field.name]: Field,
    [Tab.name]: Tab,
    [Tabs.name]: Tabs,
    [Toast.name]: Toast,
    [NoticeBar.name]: NoticeBar,
    [Dialog.Component.name]: Dialog.Component,
    [Checkbox.name]: Checkbox,
  },
  mixins: [mixins],
  created() {
    this.init();
  },
  methods: {
    init() {
      this.getPutOnBox();
    },

    scan() {
      let that = this;
      this.$wx.scanQRCode({
        needResult: 1,
        desc: "scanQRCode desc",
        success: function (a) {
          that.$set(that.search, "locationCode", a.resultStr);
        },
      });
    },

    getPutOnBox() {
      const { inventoryStorageChangeID } = this.$route.query;
      const data = { inventoryStorageChangeID };

      GetInventoryStorageChangeDetailAsync(data).then((res) => {
        if (res.status === 200) {
          const { response } = res;

          try {
            this.list = response;

            const { shippingPlanDetail, numberDetail } = response;

            this.detail = shippingPlanDetail;

            this.tableData = [
              {
                ...numberDetail,
              },
            ];
          } catch {}
        } else {
          Toast.fail(res.msg);
        }
      });
    },
showsound(isSuccess){
      if(isSuccess)
      {
          this.$refs.successaudio.currentTime=0;
          this.$refs.successaudio.play();
      }
      else
      {
          this.$refs.erraudio.currentTime=0;
          this.$refs.erraudio.play();
      }
    },
    submit() {
      const that = this;
      const { inventoryStorageChangeID } = this.$route.query;

      const data = {
        inventoryStorageChangeID,
        ...this.search,
      };

      if (!this.checkSearch()) {
        return;
      }

      Toast.loading({
        message: "上架中...",
        forbidClick: true,
      });

      addPutaway(data).then((res) => {
        Toast.clear();
        if (res.status === 200) {
          this.showsound(true);
          this.getPutOnBox();
          Toast.success("上架成功");

          setTimeout(function () {
            that.$router.go(-1);
          }, 1500);
        } else {
          this.showsound(false);
          Toast.fail(res.msg);
        }
      });
    },

    toEndPutaway() {
      const that = this;
      const { inventoryStorageChangeID } = this.$route.query;

      const data = { inventoryStorageChangeID };

      Toast.loading({
        message: "结束上架中...",
        forbidClick: true,
      });

      endPutaway(data).then((res) => {
        Toast.clear();
        if (res.status === 200) {
          this.showsound(true);
          this.getPutOnBox();
          Toast.success("结束上架成功");

          setTimeout(function () {
            that.$router.go(-1);
          }, 1500);
        } else {
          this.showsound(false);
          Toast.fail(res.msg);
        }
      });
    },

    checkSearch() {
      const { qty, locationCode } = this.search;
      if (!qty) {
        this.showsound(false);
        Toast("请输入数量");
        return false;
      }
      if (Number(qty) === 0) {
        this.showsound(false);
        Toast("数量不能为零，请重新输入");
        return false;
      }
      if (!locationCode) {
        this.showsound(false);
        Toast("请输入库位");
        return false;
      }
      return true;
    },

    inputNumChange(field) {
      let num = Number(this.search[field]);
      const c = Number(this.tableData[0].placedNumber);
      if (num > c) {
        Toast(`最大可输入数量为待上架数量`);
        num = c;
      } else if (num < 0) {
        Toast("请输入正数");
        num = Math.abs(num) > c ? c : Math.abs(num);
      }
      this.$set(this.search, field, parseInt(num));
    },

    relationNumberFmt(v) {
      return v.trim();
    },
  },
};
</script>

<style lang="less" scoped>
.signInDetail .mobileHeader {
  padding: 0 10px 15px;
  font-size: 14px;
  border-bottom: 1px solid #ccc;
  p {
    margin: 5px 0;
    display: flex;
    span {
      flex: 1;
      word-break: break-all;
      i {
        font-style: normal;
        color: #3d5064;
      }
    }
  }
}
::v-deep .van-tabs__line {
  background-color: #29c727;
}
.sign-item {
  background-color: #fbf9fe;
  padding: 10px;
  .signInDetail-content {
    font-size: 15px;
  }
  .signInDetail-btnBox {
    li {
      line-height: 40px;
    }
    .volume {
      min-width: 10%;
      max-width: 17%;
      height: 22px;
      line-height: 22px;
      font-size: 14px;
      border: 1px solid #ccc;
      outline: none;
      margin: 0 5px;
    }
  }
}
.submit-btn {
  width: 49%;
  height: 40px;
  border-radius: 5px;
  background-color: #169bd5;
  color: #fff;
  font-size: 15px;
  border: 0;
}
.confirm-btn {
  float: right;
}
.hidden {
  display: none;
}
::v-deep .van-icon-photo {
  position: absolute;
  top: 50%;
  left: 50%;
  transform: translate(-50%, -50%);
}
::v-deep .van-notice-bar {
  height: 30px;
  line-height: 30px;
  font-size: 13px;
}
::v-deep .van-cell {
  border: 1px solid #adadad;
  margin-bottom: 7px;
  padding: 5px 10px;
}
.putC_container {
  padding: 5px 10px;
  .putC_search {
    display: flex;
    line-height: 35px;
    > span {
      flex: 0.25;
      font-size: 15px;
      font-weight: 600;
      padding-right: 3%;
      text-align: right;
    }
    > div {
      flex: 0.75;
    }
  }
}
.putC_table {
  box-sizing: border-box;
  width: 100%;
  padding: 10px;
}
.putC_footer {
  margin-top: 6%;
  padding: 0 3%;
}
.red {
  color: red;
}
.mr10 {
  margin-right: 10%;
}
.putC_container .isContainTail > div {
  flex: 1;
  justify-content: flex-end;
  margin-bottom: 8px;
}
@media screen and (max-width: 320px) {
  .putC_container {
    .putC_search {
      > span {
        font-size: 12px;
      }
    }
  }
  .mobileHeader {
    span {
      font-size: 12px;
    }
  }
}
</style>